import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 作者商品费率（查询列表）
 * @param {*} query
 */
export const authorChargelist = (query) => {
    return request({
        url: `${prefix}/authorCharge/list`,
        method: 'get',
        params: query
    })
}


/**
 * 作者商品费率（创建）
 * @param {*} query
 */
export const authorChargeCreate = (query) => {
    return request({
        url: `${prefix}/authorCharge`,
        method: 'post',
        data: query
    })
}

/**
 * 作者商品费率（删除）
 * @param {*} query
 */
export const authorChargeDelete = (query) => {
    return request({
        url: `${prefix}/authorCharge`,
        method: 'delete',
        data: query
    })
}

/**
* 作者商品费率（更新）
* @param {*} query
*/
export const authorChargeEdit = (query) => {
    return request({
        url: `${prefix}/authorCharge`,
        method: 'put',
        data: query
    })
}